import React, { useEffect, useState } from "react";
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';
import Columns from "react-columns";
import Form from 'react-bootstrap/Form'
import axios from 'axios';


function App() {
  const [latest, setLatest] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchCountries, setSearchCountries] = useState("");

  useEffect(() => {
    axios
      .all([
        axios.get("https://corona.lmao.ninja/v2/all"),
        axios.get("https://corona.lmao.ninja/v2/countries"),
      ])
      .then((responseArr) => {
        setLatest(responseArr[0].data);
        setResults(responseArr[1].data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const date = new Date(parseInt(latest.updated));
  const lastUpdated = date.toString();

  const filterCountries = results.filter((item) => {
    return searchCountries !== ""
      ? item.country.toLowerCase().includes(searchCountries.toLowerCase())
      : item;
  });

  const countries = filterCountries.map((data, i)=>{
    return(
      <Card bg="#48C9B0" text="#333" className="text-centre" style={{margin:"10px"}} key={i}>
      <Card.Img variant="top" src={data.countryInfo.flag} style={{width:"100", height:"100" }}/>
        <Card.Body>
          <Card.Title>{data.country}</Card.Title>
          <Card.Text>Cases - {data.cases}</Card.Text>
          <Card.Text>Deaths {data.deaths}</Card.Text>
          <Card.Text>Recovered {data.recovered}</Card.Text>
          <Card.Text>Today's cases {data.todayCases}</Card.Text>
          <Card.Text>Today's deaths {data.todayDeaths}</Card.Text>
          <Card.Text>Active {data.active}</Card.Text>
          <Card.Text>Critical {data.critical}</Card.Text>
        </Card.Body>

      </Card>
    )
  });

  var queries = [{
      columns: 2,
      query: 'min-width: 500px'
    }, {
      columns: 3,
      query: 'min-width: 1000px'
    }];


  return (
    <div className="App">
    <h2 style={{marginTop:"70px"}}>Covid 19 live stats</h2>
    <small>Developed by Ratul Sarkar</small>
    <CardDeck style={{marginTop: "50px"}}>
<Card bg="primary" text="white" style={{margin:"0 10px 0 20px"}}>
 <Card.Body>
   <Card.Title>Cases</Card.Title>
   <Card.Text>{latest.cases}</Card.Text>
 </Card.Body>
 <Card.Footer>
   <small>Last Updated - {lastUpdated}</small>
 </Card.Footer>
</Card>
<Card bg="danger" text="white" style={{margin:"0 10px 0 20px"}}>
 <Card.Body>
   <Card.Title>Deaths</Card.Title>
   <Card.Text>{latest.deaths}</Card.Text>
 </Card.Body>
 <Card.Footer>
   <small>Last Updated - {lastUpdated}</small>
 </Card.Footer>
</Card>
<Card bg="success" text="white" style={{margin:"0 10px 0 20px"}}>
 <Card.Body>
   <Card.Title>Recovered</Card.Title>
   <Card.Text>{latest.recovered}</Card.Text>
 </Card.Body>
 <Card.Footer>
   <small>Last Updated - {lastUpdated}</small>
 </Card.Footer>
</Card>
</CardDeck>
<Form>
  <Form.Group controlId="formGroupSearch" style={{padding:"0 20px 0 20px"}}>
    <Form.Label style={{float:"left", marginTop:"15px", fontSize:"28px", fontWeight:"bold"}}>Search Country</Form.Label>
    <Form.Control
           bg="#AED6F1"
           type="text"
           placeholder="Search here"
           onChange={(e) => setSearchCountries(e.target.value)}
         />
  </Form.Group>
</Form>
<Columns queries={queries}>{countries}</Columns>
    </div>
  );
}

export default App;
